import React from 'react';
import {
  TableCellElement,
} from '@udecode/plate';

import { PlateTableCellElementResizable } from './PlateTableCellElementResizable';
import { useTableCellElementState } from './useTableCellElementState';

export const translateBorderStyle = (props) => {
  return `${props.size}px ${props.style} ${props.color}`;
};

export const getCssTableCellHandle = ({ side }) => {
  return {
    backgroundColor: '#bea06e',
    borderRadius: '5px',
    position: 'absolute',
    top: '-12px',
    [side]: '-1.5px',
    height: 'calc(100% + 12px)',
    width: '2px',
  };
};


export const PlateTableCellElement = (props) => {
  const { children, hideBorder, isHeader, ...rootProps } = props;
  const { element } = rootProps;
  const {
    colIndex,
    rowIndex,
    readOnly,
    rowSize,
    borders,
    hovered,
    hoveredLeft,
    selected,
  } = useTableCellElementState();

  const {
    bottom,
    left,
    right,
    top,
  } = borders || {};

  const style = {
    backgroundColor: element.bgColor || 'transparent',
    borderTop: top ? translateBorderStyle(top) : undefined,
    borderRight: right ? translateBorderStyle(right) : undefined,
    borderBottom: bottom ? translateBorderStyle(bottom) : undefined,
    borderLeft: left ? translateBorderStyle(left) : undefined,
    ... selected && {
      backgroundColor: 'rgba(190, 160, 110, 0.45)',
    },
  };

  return (
    <TableCellElement.Root
      asAlias={isHeader ? 'th' : 'td'}
      style={style}
      {...rootProps}
    >

      <TableCellElement.Content
        style={{
          minHeight: rowSize,
          height: '100%',
        }}
      >
        {children}
      </TableCellElement.Content>

      <TableCellElement.ResizableWrapper
        className="group"
      >
        <PlateTableCellElementResizable
          colIndex={colIndex}
          rowIndex={rowIndex}
          readOnly={readOnly}
        />
        {!readOnly && hovered && (
          <TableCellElement.Handle
            style={getCssTableCellHandle({ side: 'right' })}
          />
        )}

        {!readOnly && hoveredLeft && (
          <TableCellElement.Handle
            style={getCssTableCellHandle({ side: 'left' })}
          />
        )}
      </TableCellElement.ResizableWrapper>
    </TableCellElement.Root>
  );
};
